import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import emiter, { ON_DIALOG_REMOVE } from '@/utils/emiter';
import Modal from '../EmptyModal';
import styled from 'styled-components';
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var StyledLayout = styled.div.withConfig({
    displayName: "Dialog__StyledLayout",
    componentId: "sc-9wnnnp-0"
})([
    "text-align:left line-height:20px"
]);
function modal(config) {
    var close = function close() {
        var ref;
        d === null || d === void 0 ? void 0 : d.setState({
            visible: false
        });
        ReactDOM.unmountComponentAtNode(div);
        div === null || div === void 0 ? void 0 : (ref = div.parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(div);
        d = null;
        emiter.off(ON_DIALOG_REMOVE, onCancel);
    };
    var onCancel = function onCancel() {
        var onCancel1 = config.onCancel;
        if (typeof onCancel1 === 'function') {
            onCancel1(d === null || d === void 0 ? void 0 : d.props);
        }
        close();
    };
    var onOK = function onOK() {
        var onOK1 = config.onOK, _closeOnOk = config.closeOnOk, closeOnOk = _closeOnOk === void 0 ? true : _closeOnOk;
        if (typeof onOK1 === 'function') {
            onOK1(d === null || d === void 0 ? void 0 : d.props);
        } // delay dialog hide to get input value
        if (closeOnOk) {
            close();
        }
    };
    var div = document.createElement('div');
    document.body.appendChild(div);
    var d;
    var innerRef = config.innerRef, type = config.type, title = config.title, info = config.info, okText = config.okText, cancelText = config.cancelText, width = config.width, style = config.style, showBTN = config.showBTN, _hideTitle = config.hideTitle, hideTitle = _hideTitle === void 0 ? false : _hideTitle, footer = config.footer, confirmLoading = config.confirmLoading, _showCloseButton = config.showCloseButton, showCloseButton = _showCloseButton === void 0 ? false : _showCloseButton, contentAlign = config.contentAlign, height = config.height, mounted = config.mounted, titleAlign = config.titleAlign, buttonType = config.buttonType, icon = config.icon, clickWrappHide = config.clickWrappHide;
    var innerStyle = contentAlign ? {
        textAlign: contentAlign
    } : {};
    innerStyle = Object.assign(innerStyle, config.innerStyle || {});
    var outclick;
    if (clickWrappHide) {
        outclick = function() {
            return close();
        };
    }
    ReactDOM.render(/*#__PURE__*/ _jsx(Modal, {
        visible: true,
        innerRef: innerRef,
        hideTitle: hideTitle,
        title: title || 'Confirm',
        style: style,
        width: width || 360,
        okText: okText || 'Confirm',
        cancelText: cancelText || 'Cancel',
        onCancel: onCancel,
        showBTN: showBTN,
        onOk: onOK,
        confirmLoading: confirmLoading,
        footer: footer,
        showCloseButton: showCloseButton,
        hideCancel: type === 'alert',
        type: buttonType,
        titleAlign: titleAlign,
        height: height,
        icon: icon,
        outclick: outclick,
        children: /*#__PURE__*/ _jsx(StyledLayout, {
            style: innerStyle,
            children: typeof info === 'function' ? info({
                onCancel: onCancel
            }) : info
        })
    }), div, function() {
        d = this;
        mounted === null || mounted === void 0 ? void 0 : mounted();
        emiter.on(ON_DIALOG_REMOVE, onCancel);
    });
    return d === null || d === void 0 ? void 0 : d.props;
}
export default {
    alert: function alert(config) {
        var modalInstance;
        if (typeof config === 'string') {
            modalInstance = modal({
                type: 'alert',
                info: config
            });
        } else {
            modalInstance = modal(_objectSpread({}, config, {
                type: 'alert'
            }));
        }
        return modalInstance;
    },
    confirm: function confirm(config) {
        return modal(_objectSpread({}, config, {
            type: 'confirm'
        }));
    }
};
